/*
 * Caches the DOM for a given component.
 *
 * @param {Object} dom: the object that will hold all saved nodes
 * @param {Object} selectors: an object holding all queries for single element queries. Keys are names to reference by and value is the selector.
 * @param {Object} selectorsAll: an object holding all queries for multi element queries. Keys are names to reference by and value is the selector.
 * @param {boolean} assumeAttributes: whether the function should build queries with square brackets for data attribute querying.
 *
 *
 * Example:
 *   const dom = {};
 *   const qs = {
 *     modal: 'data-recharge-modal',
 *     title: 'data-recharge-modal-title',
 *     content: 'data-recharge-modal-content',
 *   };
 *   const qsAll = {
 *     closeButtons: 'data-close-recharge-modal'
 *   };
 *
 *   ...
 *
 *   cacheDom(dom, qs, qsAll);
 *
 */

export const cacheDom = (dom, selectors = {}, selectorsAll = {}, assumeAttributes = true, parentElement = null) => {
  Object.keys(selectors).forEach((selectorName) => {
    const selector = selectors[selectorName]
    const qs = assumeAttributes ? `[${selector}]` : selector
    dom[selectorName] = (parentElement ? parentElement.querySelector(qs) : document.querySelector(qs)) || false
  })

  Object.keys(selectorsAll).forEach((selectorName) => {
    const selector = selectorsAll[selectorName]
    const qs = assumeAttributes ? `[${selector}]` : selector
    dom[selectorName] = [...(parentElement ? parentElement.querySelectorAll(qs) : document.querySelectorAll(qs))]
  })
}
